import ButtonGroup from "@/components/ui/molecules/ButtonGroup/ButtonGroup";
import AdminSettingsCommunicateEditEmailSignature from "./AdminSettingsCommunicateEditEmailSignature";

type AdminSettingsCommunicateEmailSignatureProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  signatureValue: string;
  onSignatureChange: (value: string) => void;
}

const AdminSettingsCommunicateEmailSignature = ({ value, onChange, signatureValue, onSignatureChange }: AdminSettingsCommunicateEmailSignatureProps) => {
  const options = [
    {label: 'Oui', value: 'true'},
    {label: 'Non', value: 'false'}
  ];

  const optionToBoolean = (option: string): boolean => {
    return option === 'true';
  };

  const booleanToOption = (isActivated: boolean): string => {
    return isActivated ? 'true' : 'false';
  }

  return (
    <div className="flex flex-col gap-2w md:flex-row md:items-center md:justify-between">
      <span className='text-body1'>Afficher une signature dans l’email</span>
      <div className="flex flex-row gap-1w">
        <AdminSettingsCommunicateEditEmailSignature value={signatureValue} onSubmit={onSignatureChange} />
        <ButtonGroup className='md:flex-nowrap' options={options} onChange={(value) => onChange(optionToBoolean(value))} value={booleanToOption(value)} />
        </div>
    </div>
  );
}

export default AdminSettingsCommunicateEmailSignature;